export const ParsersTitles = {
  members: ['usersTariffs.groupChannelMembers', 'usersParsing.participants'],
  activemembers: ['usersTariffs.groupChannelActivity', 'adminTariffs.activity'],
  geomembers: ['usersTariffs.geolocation', 'usersTariffs.geolocation'],
};
